import { render, staticRenderFns } from "./LandingLayout.vue?vue&type=template&id=59a09f79&"
import script from "./LandingLayout.vue?vue&type=script&lang=ts&"
export * from "./LandingLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports